<template>
  <div class="animated fadeIn">
    <b-modal
      ref="modal-finish-card"
      scrollable
      centered
      button-size="sm"
    >
      <template #modal-title>
        <h5 class="text-bold">
          <i class="fas fa-user-slash"></i> MOTIVO DA FINALIZAÇÃO
        </h5>
      </template>
      <div class="form-group row pt-3">
        <div class="col-md-12">
          <label for="txtGroup"
            ><small
              class="text-danger"
              v-if="form.motivoId.required"
              >*</small
            >
            Motivo:</label
          >
          <div class="input-group">
            <span class="input-group-addon"
              ><i class="fas fa-user-slash"></i
            ></span>
            <b-form-select
              v-model="form.motivoId.value"
              :options="form.motivoId.options"
            >
              <template slot="first">
                <option :value="null">
                  {{ $lang.Common.PlaceholderSelect }}
                </option>
              </template>
            </b-form-select>
          </div>
        </div>
      </div>

      <div class="form-group row pt-3 pb-5">
        <div class="col-md-12">
          <label for="txtGroup">
            <small
              class="text-danger"
              v-if="form.descricaoMotivo.required"
              >*</small
            >
            Descreva:
          </label>
          <div class="input-group">
            <b-form-textarea
              id="textarea-descreva"
              rows="4"
              max-rows="8"
              v-model="form.descricaoMotivo.value"
              :required="form.descricaoMotivo.required"
              :state="form.descricaoMotivo.state"
            ></b-form-textarea>
          </div>
        </div>
      </div>

      <template #modal-footer>
        <div class="w-100 text-right">
          <button
            @click.prevent="onSetFinished"
            type="button"
            class="btn rounded btn-third btn-sm"
            v-b-tooltip.hover
            :title="'Finalizar'"
          >
            <i class="fas fa-check-circle"></i
            ><span class="d-md-down-none"> Finalizar</span>
          </button>
        </div>
      </template>
    </b-modal>
  </div>
</template>
<script>
import { createNewFollowupWithCard } from '@/components/tools/FollowupTools'
import ReasonFinishRepository from '@/shared/http/repositories/configurations/reason.js'
import BoardRepositoryV2 from '@/shared/http/repositories/crm/board_v2.js'
import ActionsForm from '@/shared/mixins/actionsForm'
import { loading, toast } from '@/shared/utils/UIHelper'
import CardFinishForm from './cardfinishmodal-form.js'

const CardFinishModel = {
  boardColumnId: null,
  motivoId: null,
  origemLeadId: null,
  pessoaId: null,
  posicao: 0,
  situacao: 0,
  reativado: 0,
  dataCriacao: null,
  dataInicioSituacao: null,
  dataReativacao: null
}

export default {
  name: 'CardFinishModal',
  mixins: [ActionsForm],
  data () {
    return {
      data: CardFinishModel,
      form: CardFinishForm,
      card: null
    }
  },
  computed: {
    leadName () {
      let result = ''
      if (this.card && this.card.pessoa && this.card.pessoa.nome) {
        result = this.card.pessoa.nome
      }
      return result
    }
  },
  mounted () {
    this.onGetAllReasonFinish()
  },
  methods: {
    showModal (data) {
      this.card = data
      this.onLoadCardSyncDb(data)
      this.$refs['modal-finish-card'].show()
    },
    hideModal () {
      this.$refs['modal-finish-card'].hide()
    },
    onLoad () {},
    onLoadCardSyncDb (card) {
      if (card) {
        this.data.id = card.id
        this.data.boardColumnId = card.boardColumn ? card.boardColumn.id : null
        this.data.motivoId = card.motivoPerda ? card.motivoPerda.id : null
        this.data.posicao = card.posicao
        this.data.situacao = card.situacao
        this.data.reativado = card.reativado
        this.data.dataCriacao = card.dataCriacao
        this.data.dataInicioSituacao = card.dataInicioSituacao
        this.data.dataReativacao = card.dataReativacao
        this.data.origemLeadId = card.origemLead ? card.origemLead.id : null
        this.data.pessoaId = card.pessoa ? card.pessoa.id : null
      }
    },
    onGetAllReasonFinish () {
      loading.push()
      ReasonFinishRepository.GetAllSituacaoActive('FINALIZADO')
        .then((response) => {
          this.form.motivoId.options = this.onResultDropdown(
            response,
            null,
            (f) => f.nome
          )
        })
        .catch(this.onException)
    },
    onSetFinished () {
      if (this.form.motivoId.value === null) {
        toast.warning(
          'Para prosseguir selecione um motivo de finalização.',
          'ATENÇÃO!'
        )
        return
      }
      if (this.data) {
        loading.push()
        const finishData = {
          id: this.data.id,
          situacao: 'FINALIZADO',
          motivoId: this.form.motivoId.value,
          dataInicioSituacao: new Date().toISOString()
        }
        BoardRepositoryV2.Card_PatchSituacao(
          this.card.boardColumn.board.id,
          this.card.boardColumn.id,
          this.card.id,
          finishData
        )
          .then((response) => {
            loading.pop()
            if (response.status === 200) {
              // Verifica se há mensagem sobre problema no e-mail
              if (response.data && response.data.message) {
                toast.warning(response.data.message, 'ATENÇÃO!')
              } else {
                toast.success(this.$lang.Common.Alerts.Success)
              }

              let value = this.form.motivoId.value
              let option = this.form.motivoId.options.find(
                (x) => x.value === value
              )
              let descricao = this.form.descricaoMotivo.value
              createNewFollowupWithCard(
                this.card.pessoa.document,
                'sys_oportunidade_finalizada',
                `Finalizou o card por motivo de ${option.text} ${
                  descricao && 'com a descrição: \n' + descricao
                }`,
                this.ip,
                this.latitude,
                this.longitude,
                this.card.id
              )
            }
            this.hideModal()
            this.$emit('Reload')
          })
          .catch(this.onException)
      } else {
        toast.success('Não foi possível localizar o Lead!', 'EXCLUSÃO DO LEAD')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/crm/details/modal/finish/cardfinishmodal.vue